module.exports = "/assets/packs/images/7f4f5e30ff03577db0395e3733816c09.svg";